export default "__VITE_ASSET__iQSz$aBH__"